import { compact, find, map } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";

export function useContextualWorkspaceEntities() {
  const workspace = useCurrentWorkspace();
  const project = useCurrentProject();
  return !!workspace && !!project
    ? compact(
        map(workspace.benchmarkEntities, (id) =>
          find(project.benchmarkEntities, { id })
        )
      )
    : [];
}
